import useMutation from "src/hooks/useMutation";

function useRemoveBulkReturnDetail(id) {
  return useMutation({
    path: id ? `/api/v1/return-logs/${id}` : `/api/v1/return-logs/id`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/return-logs`,
      shouldRevalidate: true,
    },
  });
}

export default useRemoveBulkReturnDetail;
